<template>
  <div class="g-page__row">
    <!-- <h3>{{ $t('createEnvelope.mergeFieldForm.setYourMergeFields') }}</h3> -->
    <h3>Prefill fields</h3>
    <div class="merge-field-form__instructions">
      <p>Certain fields on templates used in this envelope are marked as prefillable.</p>
      <p>You can set a value for these fields here, or leave them blank to allow recipient parties to complete them instead.</p>
      <!-- {{ $t('createEnvelope.mergeFieldForm.leaveBlankInstructions') }} -->
    </div>
    <VMergeFieldSelection
      :documents="$store.state.envelopes.creating.envelope.documents"
      v-model="fields"
    />
    <div class="g-page__row__buttons">
      <VButton
        type="cta-3"
        class="float-right"
        :action="addFields"
        :loading="isLoading"
        data-ec="envelope_send"
        data-et="merge_fields_next_step">
        <span>{{ $t('functional.nextStep') }}</span>
        <ArrowRightIcon />
      </VButton>
    </div>
  </div>
</template>

<script>
import VButton from '@/components/deprecated/atoms/Button.vue';
import VMergeFieldSelection from '@/views/components/MergeFieldSelection.vue';
import { ArrowRightIcon } from '@/components/icons/fontIcons';

export default {
  name: 'VMergeFieldForm',
  components: {
    VButton,
    VMergeFieldSelection,
    ArrowRightIcon,
  },
  data() {
    return {
      itemsLoading: 0,
      fields: {},
    };
  },
  created() {
    const envelopeHasMergeFields = !!Object.keys(this.$store.getters['envelopes/mergeFieldTags']).length;

    if (!envelopeHasMergeFields) this.$emit('nextStep');
  },
  methods: {
    async addFields() {
      try {
        this.itemsLoading += 1;
        await this.$store.dispatch('envelopes/UPDATE_FIELDS', {
          fields: this.fields,
          isCreating: true,
        });
        this.itemsLoading -= 1;
      } catch (error) {
        if (!error.response) throw error;
        this.itemsLoading -= 1;
        this.$bus.$emit('renderGlobalMessage', ({
          message: this.$t('message.fail.error', { action: 'populating the merge fields' }),
          icon: 'times',
          type: 'error',
        }));
      }

      this.$emit('nextStep');
      return true;
    },
  },
  computed: {
    isLoading() {
      return this.itemsLoading > 0;
    },
  },
};
</script>

<style scoped>
.merge-field-form__instructions {
  padding: var(--spacing-base);
  background: #fff;
  border: 1px solid var(--color-border);
  border-bottom: 0;
}
.merge-field-form__instructions:after {
  content: '';
  display: block;
  clear: both;
}
</style>
